import { render, staticRenderFns } from "./yujianfenzhen.vue?vue&type=template&id=26ed9b74&scoped=true"
import script from "./yujianfenzhen.vue?vue&type=script&lang=js"
export * from "./yujianfenzhen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ed9b74",
  null
  
)

export default component.exports